<div class="loader-container">
    <div class="load-bar" *ngIf="display">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
    </div>
</div>